import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService, Fact, LoggerService, MoneyAccount, MoneyService, RealtyService, ValueType } from '@rollit/shared/data';
import * as moment_ from 'moment';
import { randomString } from '@rollit/shared/utils';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

const moment = moment_;

@Injectable()
export class LifestyleAssetsService {
  log: any;
  sessionId: string;

  constructor(
    private moneyService: MoneyService,
    private dialogService: DialogService,
    private router: Router,
    private logger: LoggerService,
  ) {
    this.log = this.logger.info('LifestyleAssetsService');
  }

  getAccounts(): Observable<MoneyAccount[]> {
    return this.moneyService.getAccounts({ type: 'lifestyle' });
  }

  /**
   * Fetch projections for property account.
   * 
   * @param accountId 
   */
  getProjections(accountId: number, numPeriods: number): Observable<any> {
    const from = moment().startOf('month');
    return this.moneyService.getAccountProjections(accountId, from, null, numPeriods);
  }

  /**
   * start a dialog to create a new asset and (optionally) loan
   */
  startAddAsset() {
    const returnPath = this.router.url;
    this.startNewSurvey('lifestyle-asset', [], returnPath);
  }

  /**
   * Start a dialog to update asset and loan accounts. 
   * 
   * @param id The ID of the existing property account.
   */
  startUpdateAsset(id: number) {
    const facts: Fact[] = [{ slug: 'assets_lifestyle_id', type: ValueType.Long, value: id, '@type': 'fact' }];  // the property ID fact
    const returnPath = this.router.url;;
    this.startNewSurvey('lifestyle-asset', facts, returnPath);
  }

  /**
   * Start the car bvuy dialog.
   */
  startFindCar() {
    const returnPath = this.router.url;
    this.startNewSurvey('car-buy', [], returnPath);
  }

  private startNewSurvey(dialog: string, facts: Fact[], returnPath: string) {
    this.sessionId = this.dialogService.generateSessionId();

    // initialise dialog with existing facts
    this.dialogService.initDialog('track', dialog, facts, this.sessionId).subscribe(result => {
      // redirect to survey path
      this.router.navigate(['survey', 'track', dialog], { queryParams: { 'session': this.sessionId, 'return': returnPath, 'start': '_first' } });
    });
  }

}
